import LazyLoad from "vanilla-lazyload";
import Swiper, { Navigation, Thumbs } from "swiper";
import Gallery from "../blocks/gallery";
import TimelineSlider from "../blocks/timeline";
import PartnersSlider from "../blocks/partners-slider";
import Filters from "../blocks/filters";

const Common = {
  lazyLoadInstance: null,

  init() {
    this.lazyLoadInstance = new LazyLoad();

    Common.blocks();
    Common.langSwitch();
    Common.events();
    Common.tabs();
    // Common.closeNotice();
    Common.divisionNav();
    Common.sideNav();
    Common.copyProps();
    Common.anchorTags();
    Common.colorBlocks();
    Common.amroContentSliders();
    Common.newsListAjax();
  },

  blocks() {

    document.querySelectorAll(".gallery").forEach(function (gallery) {
      new Gallery(gallery);
    });

    document.querySelectorAll(".timeline").forEach(function (slider) {
      new TimelineSlider(slider);
    });

    document.querySelectorAll(".partners").forEach(function (slider) {
      new PartnersSlider(slider);
    });

    document.querySelectorAll(".filters").forEach(function (filter) {
      new Filters(filter);
    });
  },

  langSwitch() {
    document.addEventListener('DOMContentLoaded', function () {
      const toggle = document.querySelector('.lang-dropdown-toggle');
      const menu = document.querySelector('.lang-dropdown-list');

      if (toggle && menu) {
          toggle.addEventListener('click', function (e) {
              e.preventDefault();
              menu.style.display = (menu.style.display === 'block') ? 'none' : 'block';
          });

          // Close dropdown when clicking outside
          document.addEventListener('click', function (e) {
              if (!toggle.contains(e.target) && !menu.contains(e.target)) {
                  menu.style.display = 'none';
              }
          });
      }
    });
  },

  events() {

    // SEO read more toggle
    $(".seo-read-more").on("click", function () {
      $(this).parent().toggleClass("show");
    });

    // Table scroll wrapper
    $(".entry-content table").wrap(
      '<div class="scrolltable"><div class="scrolltable__inner"></div></div>'
    );
    $(".scrolltable").scroll(function () {
      $(this).addClass("scrolled");
    });

    // Video toggle
    $(".js-play-video").on("click", function () {
      const wrapper = $(this).closest(".video");
      const iframe = wrapper.find("iframe")[0];

      if (wrapper.hasClass("playing")) {
        wrapper.removeClass("playing");

        if (wrapper.find("video").length) {
          wrapper.find("video")[0].pause();
        }

        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            "*"
          );
        }
      } else {
        wrapper.addClass("playing");

        if (wrapper.find("video").length) {
          wrapper.find("video")[0].play();
        }

        if (iframe) {
          const iframeEl = $(iframe);
          const currentSrc = iframeEl.attr("src") || "";
          let targetSrc = iframeEl.data("src");

          // Load YouTube iframe once; keep src afterwards to allow resume.
          if (!currentSrc && targetSrc) {
            if (
              targetSrc.indexOf("youtube.com/embed/") !== -1 ||
              targetSrc.indexOf("youtube-nocookie.com/embed/") !== -1
            ) {
              targetSrc +=
                (targetSrc.indexOf("?") === -1 ? "?" : "&") +
                "enablejsapi=1";
            }
            iframeEl.attr("src", targetSrc);
          } else if (iframe.contentWindow) {
            iframe.contentWindow.postMessage(
              '{"event":"command","func":"playVideo","args":""}',
              "*"
            );
          }
        }
      }
    });

    // Accordion toggle
    $(".accordion").on("click", function () {
      $(this).toggleClass("active").next().slideToggle();
    });

    // SEO content toggle
    $(".seo__more-btn").on("click", function () {
      let content = document.getElementsByClassName("seo__content-2")[0];
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }

      let text = $(this).children("span").text();
      $(this).children("span").text(
        text === "LASĪT VAIRĀK" ? "Lasīt mazāk" : "Lasīt vairāk"
      );

      $(this).toggleClass("active");
    });

    // ✅ Submenu toggle
    $(".menu-item__wrap").on("click mouseenter", function (e) {
      //e.preventDefault();

      const $button = $(this);
      const $menuItem = $button.closest('li[id^="menuitem_"]');
      const menuItemId = $menuItem.attr("id");
      const submenuId = menuItemId.replace("menuitem", "submenu");

  $(".submenu").not("#" + submenuId).removeClass("active");
  $(".menu-item__wrap").not(this).removeClass("active");

  $("#" + submenuId).addClass("active");
  $button.addClass("active");
});

// Optional: hide submenu on mouse leave
$(".submenu").on("mouseleave", function () {
  $(this).removeClass("active");
  const submenuId = $(this).attr("id");
  const buttonId = submenuId.replace("submenu", "menuitem");
  $("#" + buttonId)
    .find(".menu-item__wrap")
    .removeClass("active");
});

    // Submenu hover: highlight corresponding right profile
    $(".submenu").each(function () {
      const $submenu = $(this);
      const $items = $submenu.find(".left-part .submenu-item");
      const $profiles = $submenu.find(".right-part .submenu_profile");

      // Remove any previously set active classes
      $items.removeClass("active");
      $profiles.removeClass("active");

      // Activate first item on both sides
      const $firstItem = $items.first();
      const firstKey = $firstItem.data("submenu-id");
      $firstItem.addClass("active");
      $submenu.find(`.right-part .submenu_profile.profile_${firstKey}`).addClass("active");

      // Add hover handler
      $items.on("mouseenter", function () {
        const submenuKey = $(this).data("submenu-id");
        if (!submenuKey) return;

        $items.removeClass("active");
        $(this).addClass("active");

        $profiles.removeClass("active");
        $submenu.find(`.right-part .submenu_profile.profile_${submenuKey}`).addClass("active");
      });
    });


  },

  /**
   * Tabs
   */
  tabs() {
    // Show first
    $("[data-tabs] [data-container]").not(":first-child").hide();
    $("[data-tabs] [data-target]").first().addClass("active");

    $("[data-target]").on("click", function () {
      const btnEl = $(this);
      const tabEl = btnEl.closest("[data-tabs]");

      const targetTab = btnEl.data("target");

      btnEl.parent().siblings().children().removeClass("active");
      btnEl.addClass("active");

      tabEl.find("[data-container]").hide();
      tabEl.find(`[data-container="${targetTab}"]`).show();
    });

    $('[data-target="1"]').addClass("active");
  },

  divisionNav() {
    const largeItemsBlock = $(".division-nav__large-items");

    if (largeItemsBlock.children().length > 1) {
      largeItemsBlock.addClass("has-many");
    }

    if (window.innerWidth < 1200) {
      $(".nav-item__title-wrap").on("click", function () {
        $(this).toggleClass("active").parent().next().slideToggle();
      });
    }
  },

  sideNav() {
    $(".side-nav__open-btn").on("click", function (e) {
      e.preventDefault();
      $(".side-nav").toggleClass("active");
      $("html").toggleClass("no-scroll");
    });

    $(".side-nav__item a").on("click", function (e) {
      $(".side-nav__item").removeClass("active");

      $(this).parents(".side-nav__item").addClass("active");
      $(this).parent().parent().addClass("open");
    });

    $(".side-nav__toggle").on("click", function () {
      // $(this).parent().next().slideToggle();
      $(this).parent().parent().toggleClass("open");
    });
  },

  // Copy properties and show alert

  copyProps() {
    //Copy one property to clipboard
    $(".properties-list__item").on("click", function () {
      var oneProperty = $(this)
        .find(".properties-list__item-value span")
        .text()
        .trim();
      copyText(oneProperty);

      const toggleNotice = () => {
        $(this).find(".notice").toggleClass("hidden");
      };
      toggleNotice();
      setTimeout(toggleNotice, 3500);
    });

    //Copy all properties to clipboard
    $(".properties-list__copy-all").on("click", function () {
      var allProperties = "";
      $(".properties-list")
        .find(".properties-list__item-name, .properties-list__item-value span")
        .each(function () {
          allProperties += $(this).text().trim() + "\n";
        });

      copyText(allProperties);

      const toggleNotice = () => {
        $(this).find(".notice").toggleClass("hidden");
      };

      const toggleText = () => {
        $(this).find("span").toggleClass("hidden");
      };

      toggleNotice();
      setTimeout(toggleNotice, 3500);
    });

    //Copy property URL to clipboard
    $(".properties-list__copy-link").on("click", function () {
      let url = $(this).data("url");
      copyText(url);

      const toggleNotice = () => {
        $(this).find(".notice").toggleClass("hidden");
      };
      toggleNotice();
      setTimeout(toggleNotice, 3500);
    });

    /**
     * Copy text to clipboard
     */
    function copyText(text) {
      const input = document.createElement("textarea");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
    }
  },

  anchorTags() {
    function handleAnchorTags() {
      function normalizeUrl(url) {
        try {
          const parsed = new URL(url, window.location.origin);
          return (parsed.origin + parsed.pathname).replace(/\/+$/, "");
        } catch (e) {
          return url.replace(/\/+$/, "");
        }
      }

      // Function to handle smooth scrolling
      function smoothScrollToHash(hash) {
        const viewportWidth = window.innerWidth;

        const targetElement = document.getElementById(hash);
        if (targetElement) {
          const headerOffset = (viewportWidth > 1200) ? 200 : 100;
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }

      // Handle anchor clicks
      document.querySelectorAll('a[href*="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
          // Get the current URL without the hash part
          const currentUrl = normalizeUrl(window.location.href.split('#')[0]);

          // Get the href of the anchor and split by the hash
          const anchorHref = normalizeUrl(this.href.split('#')[0]);

          // Check if the URL before the hash matches the current URL
          if (currentUrl === anchorHref) {
            e.preventDefault();

            const targetId = this.href.split('#')[1];
            smoothScrollToHash(targetId);
          }
        });
      });

      // Handle page load with hash in URL
      if (window.location.hash) {
        const initialHash = window.location.hash.substring(1); // Remove the leading #

        // Delay the scroll to ensure the content is fully loaded
        window.addEventListener('load', function () {
          // Using requestAnimationFrame to ensure the scroll happens after layout rendering
          requestAnimationFrame(() => {
            smoothScrollToHash(initialHash);
          });
        });
      }
    }
    handleAnchorTags();
  },

  colorBlocks() {
    document.querySelectorAll('[data-color]').forEach(el => {
      const color = el.getAttribute('data-color');
      el.style.backgroundColor = color;
      el.style.borderColor = color;
    });
  },

  amroContentSliders() {
    document.querySelectorAll(".amro-hero").forEach((heroEl) => {
      if (heroEl.dataset.sliderInit === "1") return;
      const swiperEl = heroEl.querySelector(".amro-hero__slider");
      if (!swiperEl || swiperEl.swiper) return;

      new Swiper(swiperEl, {
        modules: [Navigation],
        spaceBetween: -40,
        slidesPerView: 2,
        centeredSlides: true,
        loop: true,
        navigation: {
          prevEl: heroEl.querySelector(".swiper-button-prev"),
          nextEl: heroEl.querySelector(".swiper-button-next"),
        },
        breakpoints: {
          600: {
            slidesPerView: 3,
            spaceBetween: -20,
          },
        },
      });
      heroEl.dataset.sliderInit = "1";
    });

    document.querySelectorAll(".amro-cat-slider").forEach((sliderEl) => {
      if (sliderEl.dataset.sliderInit === "1") return;
      const swiperEl = sliderEl.querySelector(".swiper");
      if (!swiperEl || swiperEl.swiper) return;

      new Swiper(swiperEl, {
        modules: [Navigation],
        spaceBetween: 32,
        slidesPerView: 1.2,
        loop: true,
        navigation: {
          prevEl: sliderEl.querySelector(".swiper-button-prev"),
          nextEl: sliderEl.querySelector(".swiper-button-next"),
        },
        breakpoints: {
          600: {
            slidesPerView: 1.8,
          },
        },
      });
      sliderEl.dataset.sliderInit = "1";
    });

    document.querySelectorAll(".amro-article-slider").forEach((sliderEl) => {
      if (sliderEl.dataset.sliderInit === "1") return;
      const swiperEl = sliderEl.querySelector(".swiper");
      if (!swiperEl || swiperEl.swiper) return;

      new Swiper(swiperEl, {
        modules: [Navigation],
        spaceBetween: 32,
        slidesPerView: 1.2,
        loop: true,
        navigation: {
          prevEl: sliderEl.querySelector(".swiper-button-prev"),
          nextEl: sliderEl.querySelector(".swiper-button-next"),
        },
        breakpoints: {
          600: {
            slidesPerView: 1.8,
          },
        },
      });
      sliderEl.dataset.sliderInit = "1";
    });

    document.querySelectorAll(".amro-testi").forEach((sliderEl) => {
      if (sliderEl.dataset.sliderInit === "1") return;
      const swiperEl = sliderEl.querySelector(".swiper");
      if (!swiperEl || swiperEl.swiper) return;

      new Swiper(swiperEl, {
        modules: [Navigation],
        spaceBetween: 20,
        slidesPerView: 1,
        loop: true,
        navigation: {
          prevEl: sliderEl.querySelector(".swiper-button-prev"),
          nextEl: sliderEl.querySelector(".swiper-button-next"),
        },
      });
      sliderEl.dataset.sliderInit = "1";
    });

    document.querySelectorAll(".amro-compare").forEach((compareEl) => {
      if (compareEl.dataset.sliderInit === "1") return;
      const swiperEl = compareEl.querySelector(".swiper");
      if (!swiperEl || swiperEl.swiper) return;

      const slidesCount = compareEl.querySelectorAll(".swiper-slide").length;
      const isDesktop = window.innerWidth >= 900;
      const showNavigation = !(isDesktop && slidesCount <= 3);

      const prevButton = compareEl.querySelector(".swiper-button-prev");
      const nextButton = compareEl.querySelector(".swiper-button-next");

      if (prevButton && nextButton) {
        prevButton.style.display = showNavigation ? "" : "none";
        nextButton.style.display = showNavigation ? "" : "none";
      }

      new Swiper(swiperEl, {
        modules: [Navigation],
        spaceBetween: 8,
        slidesPerView: "auto",
        centeredSlides: true,
        initialSlide: 1,
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton,
        },
        breakpoints: {
          900: {
            spaceBetween: 32,
          },
          600: {
            spaceBetween: 16,
          },
        },
      });
      compareEl.dataset.sliderInit = "1";
    });

    document.querySelectorAll(".amro-showcase").forEach((showcaseEl) => {
      if (showcaseEl.dataset.sliderInit === "1") return;
      const thumbsEl = showcaseEl.querySelector("[data-amro-showcase-thumbs]");
      const mainEl = showcaseEl.querySelector("[data-amro-showcase-main]");
      const prevEl = showcaseEl.querySelector(".swiper-button-prev");
      const nextEl = showcaseEl.querySelector(".swiper-button-next");

      if (!thumbsEl || !mainEl || mainEl.swiper) return;

      const thumbsSlider = new Swiper(thumbsEl, {
        slidesPerView: "auto",
        spaceBetween: 4,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        allowTouchMove: true,
        breakpoints: {
          0: {
            direction: "horizontal",
            slidesPerView: "auto",
            allowTouchMove: true,
          },
          900: {
            direction: "vertical",
            allowTouchMove: false,
          },
        },
      });

      const mainSlider = new Swiper(mainEl, {
        modules: [Navigation, Thumbs],
        slidesPerView: 1,
        spaceBetween: 16,
        autoHeight: true,
        thumbs: {
          swiper: thumbsSlider,
        },
        navigation: {
          prevEl,
          nextEl,
        },
        on: {
          init: function () {
            if (window.innerWidth < 900) {
              thumbsSlider.slideTo(this.activeIndex);
            }
          },
          slideChange: function () {
            this.slides.forEach((slide) => {
              const iframe = slide.querySelector("iframe");
              if (iframe) {
                const src = iframe.src;
                iframe.src = src;
              }
            });

            if (window.innerWidth < 900) {
              thumbsSlider.slideTo(this.activeIndex);
            }
          },
        },
      });

      const refreshShowcaseHeight = () => {
        requestAnimationFrame(() => {
          if (mainSlider && typeof mainSlider.updateAutoHeight === "function") {
            mainSlider.updateAutoHeight(300);
          }
        });
      };

      mainEl.querySelectorAll("img, video").forEach((mediaEl) => {
        mediaEl.addEventListener("load", refreshShowcaseHeight, { passive: true });
        mediaEl.addEventListener("loadeddata", refreshShowcaseHeight, { passive: true });
        mediaEl.addEventListener("loadedmetadata", refreshShowcaseHeight, { passive: true });
      });

      showcaseEl.addEventListener("click", (event) => {
        if (event.target.closest(".js-play-video")) {
          setTimeout(refreshShowcaseHeight, 80);
        }
      });

      showcaseEl.dataset.sliderInit = "1";
    });
  },

  newsListAjax() {
    document.addEventListener("click", async (e) => {
      const link = e.target.closest(
        "[data-news-ajax-root] [data-news-categories] a, [data-news-ajax-root] [data-news-load-more] a"
      );

      if (!link) return;

      const root = link.closest("[data-news-ajax-root]");
      if (!root) return;

      const isLoadMore = !!link.closest("[data-news-load-more]");
      e.preventDefault();

      const targetUrl = link.getAttribute("href");
      if (!targetUrl) return;

      if (root.classList.contains("is-loading")) return;
      root.classList.add("is-loading");

      try {
        const response = await fetch(targetUrl, {
          headers: { "X-Requested-With": "XMLHttpRequest" },
        });

        if (!response.ok) throw new Error("Failed to load news list");

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newRoot = doc.querySelector("[data-news-ajax-root]");

        if (!newRoot) {
          if (!isLoadMore) {
            window.location.href = targetUrl;
          }
          return;
        }

        if (isLoadMore) {
          const currentList = root.querySelector("[data-news-list]");
          const incomingList = newRoot.querySelector("[data-news-list]");
          const currentLoadMore = root.querySelector("[data-news-load-more]");
          const incomingLoadMore = newRoot.querySelector("[data-news-load-more]");

          if (!currentList || !incomingList) {
            window.location.href = targetUrl;
            return;
          }

          // Append top-level list items as rendered by template (e.g. .news-list__item).
          Array.from(incomingList.children).forEach((item) => {
            currentList.appendChild(item);
          });

          if (incomingLoadMore) {
            if (currentLoadMore) {
              currentLoadMore.replaceWith(incomingLoadMore);
            } else {
              currentList.after(incomingLoadMore);
            }
          } else if (currentLoadMore) {
            currentLoadMore.remove();
          }
        } else {
          root.replaceWith(newRoot);
        }

        if (Common.lazyLoadInstance) {
          Common.lazyLoadInstance.update();
        }
      } catch (err) {
        if (!isLoadMore) {
          window.location.href = targetUrl;
        }
      } finally {
        root.classList.remove("is-loading");
      }
    });

  }

};

export default Common;
